<template>
  <b-modal :title="mode + ' User'"
    v-model="showModal"
    @ok.prevent="submit"
    :ok-disabled="sending"
    @cancel.prevent="cancel"
    @hidden="cancel"
  >
    <b-form @submit.prevent>
      <b-form-group
        label="Name"
        label-for="edit-user-name"
        invalid-feedback="Please enter a name">
        <b-form-input
          id="edit-user-name"
          v-model.trim="form.name"
          required
          :state="errors.length == 0 ? null : form.name != ''"
          maxlength="100"
          autofocus>
        </b-form-input>
      </b-form-group>
      <b-form-group
        label="Job Title"
        label-for="edit-user-job-title"
        invalid-feedback="Please enter a job title">
        <b-form-input
          id="edit-user-job-title"
          v-model.trim="form.jobTitle"
          maxlength="50"
          :state="errors.length == 0 ? null : form.jobTitle ? true : null"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="Email"
        label-for="edit-user-email"
        invalid-feedback="Please enter a valid email">
        <b-form-input id="edit-user-email"
          v-model.trim="form.email"
          required
          maxlength="254"
          :state="errors.length == 0 ? null : validEmail"
          :disabled="mode === 'Edit'">
        </b-form-input>
      </b-form-group>
      <b-form-group
        label="Mobile Phone"
        label-for="edit-user-phone"
        invalid-feedback="Please enter a valid phone number">
        <b-form-input id="edit-user-phone" 
          v-model="form.phone"
          type="tel"
          :state="errors.length == 0 ? null : validPhone"
          v-mask="'(###) ###-####'">
        </b-form-input>
      </b-form-group>
      <BaseMessageBlock :messages="errors"></BaseMessageBlock>
      <template v-slot:modal-ok >
        <b-spinner small v-if="sending" label="Spinning" />
        <div v-else>
          <div v-if="mode === 'Add' || mode === 'Create'">Add</div>
          <div v-if="mode === 'Edit'">Save</div>
        </div>
      </template>
    </b-form>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  props: {
    userEmails: { type: Array, default: () => [] },
    user: { type: Object, default: null },
    mode: { type: String, default: "Add" }
  },
  data() {
    let userForm = {
      userId: '',
      name: '',
      email: '',
      phone: '',
      jobTitle: ''
    };

    if (this.user) {
      userForm.userId = this.user.userId;
      userForm.name = this.user.name;
      userForm.jobTitle = this.user.jobTitle;
      userForm.email = this.user.email;
      userForm.phone = this.user.phone;
    }

    return {
      errors: [],
      sending: false,
      form: userForm,
      showModal: false
    }
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide(){
      this.showModal = false;
    },
    submit() {
      if (this.mode === "Add") {
        this.addUser();
      } else if (this.mode === "Edit") {
        this.editUser();
      } else if (this.mode === 'Create') {
        this.createUser();
      }
    },
    cancel() {
      this.resetForm();
      this.hide();
    },
    validateUser(){
      const initErrors = this.errors.length;
      if (!this.form.name){
        this.errors.push({message: 'Name cannot be empty'})
      }

      let re =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.form.email = this.form.email.toLowerCase();
      if (!this.form.email.length){
        this.errors.push({message: 'Email cannot be empty' })
      } else if (!(re.test(this.form.email))){
        this.errors.push({ message: 'Email must be valid' });
      } else if (this.userEmails.find(u => u === this.form.email)) {
        this.errors.push({ message: `User with email '${this.form.email}' already exists` });
      }

      if (this.validPhone === false) {
        this.errors.push({message: 'Phone number must be 10 digits long'})
      }

      return initErrors === this.errors.length;
    },
    addUser() {
      this.errors = [];

      if (!this.validateUser()) {
        return;
      }

      let request = {
        ...this.form
      };
      request.userId = this.$helpers.generateUUID();

      this.sending = true;
      axios
        .post(`${this.$api_url}/users/add`, request, this.getReqConfig())
        .then(() => {
          //Add it to the list of project users
          this.$emit('submitted');
          this.resetForm();
          this.hide();
        })
        .catch(err => {
          if (err.response && err.response.data) {
              this.errors.push(...(err.response.data.map(d => ({message: d}))));
          } else{
            this.errors.push(err);
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    editUser() {
      throw "function 'editUser' is not implemented";
    },
    createUser() {
      this.errors = [];

      if (!this.validateUser()) {
        return;
      }

      let user = { ...this.form };
      user.userId = this.$helpers.generateUUID();
      this.$emit('create', user);
      this.resetForm();
      this.hide();
    },
    resetForm() {
      this.errors = [];
      this.form = {
        userId: '',
        name: '',
        jobTitle: '',
        email: '',
        phone: '',
      };
    },
  },
  computed: {
    validEmail() {
      let re =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !!this.form.email && re.test(this.form.email);
    },
    validPhone() {
      return this.form.phone
        ? this.form.phone.replace(/[^0-9]/g, '').length === 10
        : null
    }
  }
}

</script>